import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=32a67deb&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=ts&"
export * from "./LoginPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=32a67deb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a67deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a67deb')) {
      api.createRecord('32a67deb', component.options)
    } else {
      api.reload('32a67deb', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=32a67deb&scoped=true&", function () {
      api.rerender('32a67deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/LoginPage.vue"
export default component.exports